
export const PeOverviewSummaryState = {
  summary: {
    collapsed: true,
  },
}

export const PeOverviewSummaryGetters = {
  peOverviewSummaryCollapsed: state => state.partyEdit.overview.summary.collapsed,
}
export const PeOverviewSummaryMutations = {
  setPeOverviewSummaryCollapsed: (state, collapsed) => {
    state.partyEdit.overview.summary.collapsed = collapsed
  },
}
